<div #modalRef class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="appDownloadModal" tabindex="-1" aria-labelledby="appDownloadModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content glassmorphism-card rounded-lg px-2 px-lg-5 py-3">
      <div class="modal-header border-bottom">
        <h4 class="modal-title font-weight-bold" id="appDownloadModalLabel">
          حمل تطبيق الأفق الآن
        </h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="إغلاق"></button>
      </div>
      <div class="modal-body pt-0">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12 text-center mb-3">
              <img src="assets/img/portal-app.webp" alt="Alofoq App" class="img-fluid rounded shadow-sm" style="max-height: 180px; object-fit: contain;">
            </div>
            <div class="col-12 text-center mb-4">
              <h5 class="font-weight-bold mb-2">احصل على كل خدماتك بسهولة من تطبيق الأفق</h5>
              <p class="text-muted mb-0">حمل التطبيق الآن على هاتفك وتمتع بتجربة أفضل وأسرع لإدارة حسابك وخدماتك.</p>
            </div>
            <div class="col-12 d-flex justify-content-center gap-3 mb-3 flex-wrap">
              <a href="https://apps.apple.com/in/app/alofoq-portal/id1634190952" target="_blank" class="me-2">
                <img src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store" style="height: 48px;">
              </a>
              <a href="https://play.google.com/store/apps/details?id=ly.alofoq.userportal&pcampaignid=web_share" target="_blank">
                <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Get it on Google Play" style="height: 48px;">
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
